export function SectionCard({ title, description, testId, footer, children }) {
  return (
    <section data-testid={testId} className="rounded-lg border border-border bg-card">
      <div className="grid gap-8 p-6 sm:p-8 lg:grid-cols-[220px_1fr] lg:gap-12">
        <header>
          <h2 className="font-serif text-2xl tracking-tight">{title}</h2>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{description}</p>
        </header>
        <div className="min-w-0">{children}</div>
      </div>
      {footer && <div className="border-t border-border px-6 py-4 sm:px-8">{footer}</div>}
    </section>
  );
}
